module.exports = __webpack_public_path__ + "static/img/service_h5_06_zh.4035668.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/service/service_h5_06_zh.png
// module id = V8O2
// module chunks = 34